import { useTranslation } from 'react-i18next'

import { DeliveryInfo } from '@widgets/delivery-info'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'

export default function DeliveryPage () {
  const { t } = useTranslation('seo')
  return (
    <>
      <SEO
        title={t('delivery.title', { brand: BRAND_NAME })}
        description={t('delivery.description', { brand: BRAND_NAME })}
      />
      <DeliveryInfo />
    </>
  )
}
